/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';

export const productCardSX: SxProps = {
	position:'relative',
	p: globalBreak({mobile:1.5, desktop:2}),
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	'&:hover': {
		boxShadow: 3,
	},
};
